import { render, staticRenderFns } from "./quality-scores-modal.vue?vue&type=template&id=7812ded6&scoped=true"
import script from "./quality-scores-modal.vue?vue&type=script&lang=js"
export * from "./quality-scores-modal.vue?vue&type=script&lang=js"
import style0 from "./quality-scores-modal.vue?vue&type=style&index=0&id=7812ded6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7812ded6",
  null
  
)

export default component.exports